"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CommonPageHelper {
    static isLoggedInAdminRole() {
        return document.body.classList.contains('logged-in-admin-role');
    }
}
exports.default = CommonPageHelper;
